exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._zR2M{margin-bottom:48px;margin-top:32px}._MPvx{max-width:560px}._3tpB{margin-top:30px}._1FEL,._330i{font-size:14px;line-height:20px;color:#536e92}._330i{margin:4px 0 16px}._9aye{font-size:12px;line-height:16px;color:#182233;margin:0}._3pKq{font-weight:700}._1FEL{padding:6px 16px;display:inline-block;margin-top:24px;cursor:pointer}._1FEL,._255m{border:1px solid #e6ebf3}._255m{position:relative;padding-bottom:55px}._8znW{position:absolute;left:16px;bottom:16px}._3QnS{padding:12px;border-radius:2px;overflow:scroll}._1yn-{vertical-align:middle;margin-right:4px}._2uIp{opacity:0;display:none;font-size:14px;line-height:20px;background:#536e92;color:#fff;padding:6px 16px;border:1px solid #536e92;display:inline-block;margin:24px 0 0 20px;border-radius:4px;-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0)}._4ZrH{opacity:1;-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);display:inline-block;-webkit-transition:all .4s ease;transition:all .4s ease}", ""]);

// exports
exports.locals = {
	"code-int": "_zR2M",
	"code-inner": "_MPvx",
	"ser-int": "_3tpB",
	"sub-txt": "_330i",
	"copy-code": "_1FEL",
	"code-txt": "_9aye",
	"bold": "_3pKq",
	"code-block-wrap": "_255m",
	"code-btn-block": "_8znW",
	"code-block": "_3QnS",
	"copy-icon": "_1yn-",
	"code-copied": "_2uIp",
	"copied": "_4ZrH"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!./checkout/components/async/codeintegration/style.css
// module id = IOev
// module chunks = 3